export function getMarginTradeState(value, def = '') {
  switch (value) {
    case 0:
      return '待付款';
    case 10:
      return '冻结中';
    case 20:
      return '违约扣除';
    case 30:
      return '已退款';
    case 100:
      return '取消';
    default:
      return def;
  }
}

// 保证金订单是否能退款
export function canMarginRefund(data) {
  return (
    data.payState === 60 &&
    // data.existOnlinePay &&
    data.marginAmount > 0 &&
    (data.tradeState == 10 || data.tradeState == 20)
  );
}
